import Footer from './Footer';
import Footer1 from './Footer1';
import Footer2 from './Footer2';
import Footer6 from './Footer6';
import FooterThemeTen from './FooterThemeTen';
import React from 'react';
import ThemeEightFooter from '../../ThemeEight/common/ThemeEightFooter';
import ThemeElevenFooter from '../../ThemeEleven/components/ThemeElevenFooter';
import ThemeFourFooter from '../../ThemeFour/common/ThemeFourFooter';
import ThemeNineFooter from '../../ThemeNine/common/ThemeNineFooter';
import ThemeSevenFooter from '../../ThemeSeven/common/ThemeSevenFooter';
import ThemeThreeFooter from '../../ThemeThree/common/ThemeThreeFooter';

// import Footer3 from './Footer3';
// Footer5  is for saopaulo for info
// import Footer5 from './Footer5';

const MainFooter = ({ operator }) => {
  const getFooter = () => {
    const themeType = operator && operator.theme_type && operator.theme_type;
    if (themeType === 1 ) {
      return <Footer1 operator={operator} />;
    } else if (themeType === 2) {
      return <Footer operator={operator} />;
    } else if (themeType === 3) {
      return <ThemeThreeFooter operator={operator} />;
    } else if (themeType === 5) {
      return <Footer2 operator={operator} />;
    } else if (themeType === 6) {
      return <Footer6 operator={operator} />;
    } else if (themeType === 7) {
      return <ThemeSevenFooter operator={operator} />;
    } else if (themeType === 4) {
      return <ThemeFourFooter operator={operator} />;
    } else if (themeType === 8) {
      return <ThemeEightFooter operator={operator} />;
    } else if (themeType === 9) {
      return <ThemeNineFooter operator={operator} />;
    } else if (themeType === 10) {
      return <FooterThemeTen operator={operator} />;
    }else if (themeType === 11) {
      return <ThemeElevenFooter operator={operator} />;
    }
    return <div />;
  };

  return <React.Fragment>{getFooter()}</React.Fragment>;
};

export default MainFooter;



// WEBPACK FOOTER //
// ./src/features/themes/common/footer/MainFooter.js